import { render, staticRenderFns } from "./rankDetails.vue?vue&type=template&id=2a976fd6&scoped=true&"
import script from "./rankDetails.vue?vue&type=script&lang=js&"
export * from "./rankDetails.vue?vue&type=script&lang=js&"
import style0 from "./rankDetails.vue?vue&type=style&index=0&id=2a976fd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a976fd6",
  null
  
)

export default component.exports